import { isApsScheelCustom } from "@src/domains/shared/constants/deploymentVariant";

type Holiday = {
  date: string;
  name: string;
};

const getHolidays = (year: number): Holiday[] => {
  const holidays: Holiday[] = [];

  holidays.push({
    date: `${year}-01-01`,
    name: "Neujahrstag (New Year's Day)",
  });
  holidays.push({
    date: `${year}-01-06`,
    name: "Heilige Drei Könige (Epiphany)",
  });
  holidays.push({ date: `${year}-05-01`, name: "Tag der Arbeit (Labour Day)" });

  if (isApsScheelCustom) {
    holidays.push({
      date: `${year}-08-08`,
      name: "Friedensfest (Peace Festival, Augsburg only)",
    });
  }

  holidays.push({
    date: `${year}-08-15`,
    name: "Mariä Himmelfahrt (Assumption Day)",
  });
  holidays.push({
    date: `${year}-10-03`,
    name: "Tag der Deutschen Einheit (German Unity Day)",
  });
  holidays.push({
    date: `${year}-11-01`,
    name: "Allerheiligen (All Saints' Day)",
  });
  holidays.push({
    date: `${year}-12-25`,
    name: "Erster Weihnachtstag (Christmas Day)",
  });
  holidays.push({
    date: `${year}-12-26`,
    name: "Zweiter Weihnachtstag (Second Day of Christmas)",
  });

  // Movable holidays based on Easter
  const easterDate = getEasterDate(year);
  holidays.push({
    date: formatDate(subDays(easterDate, 2)),
    name: "Karfreitag (Good Friday)",
  });
  holidays.push({
    date: formatDate(addDays(easterDate, 1)),
    name: "Ostermontag (Easter Monday)",
  });
  holidays.push({
    date: formatDate(addDays(easterDate, 39)),
    name: "Christi Himmelfahrt (Ascension Day)",
  });
  holidays.push({
    date: formatDate(addDays(easterDate, 50)),
    name: "Pfingstmontag (Whit Monday)",
  });
  holidays.push({
    date: formatDate(addDays(easterDate, 60)),
    name: "Fronleichnam (Corpus Christi)",
  });

  return holidays;
};

// Helper functions
const getEasterDate = (year: number): Date => {
  const f = Math.floor;
  // Computus algorithm to calculate Easter Sunday
  const G = year % 19;
  const C = f(year / 100);
  const H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30;
  const I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11));
  const J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7;
  const L = I - J;
  const month = 3 + f((L + 40) / 44);
  const day = L + 28 - 31 * f(month / 4);
  return new Date(year, month - 1, day); // Month is 0-based
};

const addDays = (date: Date, days: number): Date => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};

const subDays = (date: Date, days: number): Date => {
  return addDays(date, -days);
};

const formatDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

const currentYear = new Date().getFullYear();
const yearsToGenerate: number[] = Array.from(
  { length: 10 },
  (_, i) => currentYear + i,
);
export const allHolidays: Holiday[] = yearsToGenerate.flatMap(getHolidays);
